import { module } from 'modujs';
import { html } from '../utils/environment';
import { lerp } from '../utils/maths';
import { transform } from '../utils/transform';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: {
                wrap: 'enter'
            },
            mouseleave: {
                wrap: 'leave'
            }
        }
    }

    init() {

        this.$projects = this.$('project');

        if (window.isMobile) return;

        this.bcr = this.el.getBoundingClientRect();

        this.mouse = {
            x: this.bcr.width / 2,
            y: this.bcr.width / 2,
            lerpedX: this.bcr.width / 2,
            lerpedY: this.bcr.height / 2
        }

        this.isAvailable = false;
        this.$visual = this.$('visual')[0];

        this.bindEnter = this.projectHover.bind(this);
        this.bindLeave = this.projectLeave.bind(this);
        // Handmade events
        this.$projects.forEach(el => {
            el.addEventListener('mouseover', this.bindEnter);
            el.addEventListener('mouseleave', this.bindLeave);
        });

        this.bindMousemove = this.mousemove.bind(this);
        window.addEventListener('mousemove', this.bindMousemove);

        this.bindResize = this.resize.bind(this);
        window.addEventListener('mousemove', this.bindResize);

        // init position
        transform(this.$visual, `translate3d(${this.mouse.lerpedX}px,${this.mouse.lerpedY}px,0) translate3d(-50%, -50%, 0) rotate(0deg)`)

    }

    projectHover(e) {
        this.setActive(e.currentTarget);
    }

    setActive(el) {
        // el.setAttribute('data-leaving', 'false');
        // el.classList.add('is-active');
        this.$visual.style.backgroundImage = `url(${el.getAttribute('data-visual')})`;
    }

    projectLeave(e) {
        // let el = e.currentTarget;
        // el.setAttribute('data-leaving', 'true');

        // this.hoverDelayedCall = gsap.delayedCall(0.2, () => {
        //     if (el.getAttribute('data-leaving') == 'true') {

        //         el.setAttribute('data-leaving', 'false');
        //         el.classList.remove('is-active');
        //     }
        // });
    }


    animate() {
        this.raf = requestAnimationFrame(() => this.animate());

        if (this.isAvailable) {
            this.mouse.lerpedX = lerp(this.mouse.lerpedX, this.mouse.x, 0.05);
            this.mouse.lerpedY = lerp(this.mouse.lerpedY, this.mouse.y, 0.05);

            const rotation = (this.mouse.x - this.mouse.lerpedX) * 0.03;

            transform(this.$visual, `translate3d(${this.mouse.lerpedX}px,${this.mouse.lerpedY}px,0) translate3d(-50%, -50%, 0) rotate(${rotation}deg)`)
        }
    }

    mousemove(e) {
        this.mouse.x = e.clientX;
        this.mouse.y = e.clientY - this.bcr.top;
    }

    resize() {
        this.bcr = this.el.getBoundingClientRect();
    }

    enter() {
        cancelAnimationFrame(this.raf);

        if (this.leaveCallback !== undefined) {
            this.leaveCallback.kill();
        }
        this.isAvailable = true;

        this.animate();
    }

    leave() {
        this.leaveCallback = gsap.delayedCall(0.3, () => {
            this.isAvailable = false;
            cancelAnimationFrame(this.raf);
        });
    }

    destroy() {
        if (window.isMobile) return;

        this.$projects.forEach(el => {
            el.removeEventListener('mouseenter', this.bindEnter);
            el.removeEventListener('mouseleave', this.bindLeave);
        });

        window.removeEventListener('mousemove', this.bindMousemove);
        cancelAnimationFrame(this.raf);
    }
}
